import { Icon } from '@vrplatform/icons';
import { useAppName } from '@vrplatform/theme';
import {
  Box,
  type BoxProps,
  Group,
  Stack,
  Text,
  Transition,
  rem,
} from '@mantine/core';
import { useMissingAccountAssignmentsQuery } from '@vrplatform/data';

export const MissingAccountAssignmentsBanner = (props?: BoxProps) => {
  const { data } = useMissingAccountAssignmentsQuery();
  const { appName } = useAppName();

  return (
    <Transition
      mounted={!!data?.length}
      transition="fade"
      duration={400}
      timingFunction="ease"
    >
      {(styles) => (
        <Box
          my="md"
          style={styles}
          sx={(theme) => ({
            backgroundColor: '#FFF7ED',
            border: '1px solid #FFEDD5',
            paddingLeft: rem(12),
            paddingRight: rem(16),
            paddingTop: rem(12),
            paddingBottom: rem(12),
            borderRadius: rem(8),
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: rem(24),
            [`@media (max-width: ${theme.breakpoints.xs})`]: {
              flexDirection: 'column',
              alignItems: 'stretch',
              textAlign: 'center',
            },
          })}
          {...props}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              width: rem(32),
              height: rem(75),
              paddingTop: rem(8),
              flexShrink: 0,
            }}
          >
            <Icon icon="AlertTriangleIcon" size={24} color="#EA580C" />
          </Box>
          <Stack gap={rem(12)} sx={{ flex: 1 }}>
            <Stack gap={rem(2)}>
              <Text
                fw={600}
                c="#171717"
                sx={{
                  fontSize: rem(14),
                  lineHeight: 1.4,
                  letterSpacing: rem(-0.09),
                }}
              >
                Map your accounts to continue
              </Text>
              <Text
                fw={400}
                c="#333"
                sx={{
                  fontSize: rem(14),
                  lineHeight: 1.4,
                  letterSpacing: rem(-0.09),
                }}
              >
                We've found some accounts that are missing assignments. Please
                assign the following to continue using {appName}:
              </Text>
            </Stack>

            <Group gap={rem(7)}>
              {data?.map((x) => (
                <Box
                  key={x.id}
                  component="span"
                  sx={{
                    border: '0.5px solid rgba(0, 0, 0, 0.2)',
                    borderRadius: rem(4),
                    paddingLeft: rem(4),
                    paddingRight: rem(4),
                    paddingTop: rem(2),
                    paddingBottom: rem(2),
                    height: rem(21),
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    fontSize: rem(12),
                    lineHeight: 1.4,
                    color: '#333',
                    letterSpacing: rem(0.01),
                  }}
                >
                  {x.title}
                </Box>
              ))}
            </Group>
          </Stack>
        </Box>
      )}
    </Transition>
  );
};
